import axios from "axios";
import { API } from "../context/ContentContext";

const TOKEN_KEY = "kapil_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
export const isLoggedIn = () => !!getToken();

const authHeader = () => ({ Authorization: `Bearer ${getToken()}` });

export const adminLogin = async (password) => {
  const res = await axios.post(`${API}/admin/login`, { password });
  if (res.data.token) setToken(res.data.token);
  return res.data;
};

export const adminLogout = () => {
  clearToken();
};

export const verifyAdmin = async () => {
  try {
    await axios.get(`${API}/admin/me`, { headers: authHeader() });
    return true;
  } catch (e) {
    clearToken();
    return false;
  }
};

export const fetchContent = async (key) => {
  const res = await axios.get(`${API}/content/${key}`);
  return res.data.value;
};

export const updateContent = async (key, value) => {
  const res = await axios.put(
    `${API}/admin/content/${key}`,
    { value },
    { headers: authHeader() }
  );
  return res.data;
};

export const resetContent = async (key) => {
  const res = await axios.post(
    `${API}/admin/content/${key}/reset`,
    {},
    { headers: authHeader() }
  );
  return res.data;
};

export const uploadImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const res = await axios.post(`${API}/admin/upload`, fd, {
    headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
  });
  // Convert relative /api/uploads/... to absolute URL
  const url = res.data.url.startsWith("http")
    ? res.data.url
    : `${process.env.REACT_APP_BACKEND_URL}${res.data.url}`;
  return { id: res.data.id, url };
};
